import storage from 'good-storage'


const CACHE_KEY = '_sj_'


export function loadData() {
  return storage.get(CACHE_KEY, {})
}

export function saveCatch(key, val) {
  let data = storage.get(CACHE_KEY, {})
  data[key] = val
  storage.set(CACHE_KEY, data)
  return data
}

export function getTreeData1 (data) {
  let treeData = []
  if (data.length > 0) {
    treeData.push({id: data[0].dept_id, label: data[0].dept_name, children: [] })
  }
  addTreeData1(data, treeData)
  return treeData
}

function addTreeData1 (data, treeData) {
  treeData.map(val => {
    let dataList = data.filter(obj => {return obj.parent_id === val.id})
    dataList.map(obj => {
      val.children.push({id: obj.dept_id, label: obj.dept_name, children: [] })
    })
    addTreeData1(data, val.children)
  })
}

// 菜单递归
export function getTreeData (data) {
  let treeData = []
  if (data.length > 0) {
    data.forEach(item => {
      if (!item.parent_id) {
        treeData.push({id:item.dept_id, label: item.mc, children: [] })
      }
    });
  }
  addTreeData(data, treeData)
  return treeData
}

function addTreeData (data,treeData) {
  treeData.map(val=>{
    let dataList = data.filter(obj => {return obj.parent_id === val.id})
    dataList.map(item=>{
      val.children.push({id:item.dept_id, label: item.mc, children: []})
    })
    addTreeData(data, val.children)
  })
}